import { getCurrentBalance } from "../../js/api/balance.js";
import { createUser } from "../../js/api/users.js";
import { _t } from "../../services/TranslationService.js";
import Utils from "../../services/Utils.js";
let role = localStorage.getItem("role");

let CreateUsers = {
  render: async () => {
    let view = /*html*/ `
            <div class="createUsersHeader">
                 <a class="backBtn">
                    <svg width="25" height="25" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="#939393" d="M8.84182 3.13514C9.04327 3.32401 9.05348 3.64042 8.86462 3.84188L5.43521 7.49991L8.86462 11.1579C9.05348 11.3594 9.04327 11.6758 8.84182 11.8647C8.64036 12.0535 8.32394 12.0433 8.13508 11.8419L4.38508 7.84188C4.20477 7.64955 4.20477 7.35027 4.38508 7.15794L8.13508 3.15794C8.32394 2.95648 8.64036 2.94628 8.84182 3.13514Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>
                </a>
                 <span>${_t("Krijo Perdorues te ri")}</span>
           </div>
           <div class="createUsersWrapper m-t-6">
                <div class="createUsersHolder m-t-6">
                  <div class="form-group">
                    <input type="text" placeholder="${_t("Perdoruesi")}" id="txtUsername">
                    <input type="password" placeholder="${_t("Fjalekalimi")}" id="txtPassword">
                  </div>
                  <div class="form-group">
                    <input type="text" placeholder="${_t("Emri")}" id="txtFirstName">
                    <input type="text" placeholder="${_t("Mbiemri")}" value="" id="txtSurname">
                  </div>
                    ${
                      role == "SupermanagerTest"
                        ? `
                      <input type="number" placeholder="% - 1" value="4" id="txtSinglePercentage">
                      <input type="number" placeholder="% - 2" value="8" id="txtDoublePercentage">
                      <input type="number" placeholder="% - 3" value="8" id="txtTriplePercentage">`
                        : ""
                    }
                    <div class="form-group">
                      <select name="" id="selectCurrency">
                      </select>
                    </div>

                    <a class="updateCreateUserBtn" id="createUserBtn" style="margin-top: 0; margin-bottom: 15px">${_t("Regjistrohu")}</a>
                </div>
            </div>
       `;
    return view;
  },
  after_render: async () => {
    var currentBalanceResult = await getCurrentBalance();
    var allText = "";

    if (
      role == "Supermanager" ||
      role == "Manager" ||
      role == "Administrator" ||
      role == "Superadmin" ||
      role == "CompanyAdmin"
    ) {
      $("#selectCurrency").append(`<option value="0"> 
        ${_t("Të gjitha")}
      </option>`);
    }

    if (currentBalanceResult.total_coins.includes("|")) {
      var allCoins = currentBalanceResult.total_coins.split("|");

      allCoins.forEach((element) => {
        const currencyId = element.split(";")[0].split(".")[0];
        const currency = element.split(";")[0].split(".")[1];

        $("#selectCurrency").append(`<option value="${currencyId}"> 
         ${currency}
        </option>`);
      });
    } else {
      if (currentBalanceResult.currency) {
        $("#selectCurrency")
          .append(`<option value="${currentBalanceResult.currency_id}"> 
        ${Utils.currencyCode(currentBalanceResult.currency)}
      </option>`);
      } else {
        const currency = currentBalanceResult.total_coins
          .split(";")[0]
          .split(".")[1];
        const value = currentBalanceResult.total_coins.split(";")[1];
        const id = currentBalanceResult.total_coins.split(";")[0].split(".")[0];
        $("#selectCurrency").append(`<option value="${id}"> 
        ${currency}
      </option>`);
      }
    }

    //name,surname,username,email,password,currency

    const submitBtn = document.getElementById("createUserBtn");
    if (submitBtn) {
      submitBtn.addEventListener("click", async () => {
        const Username = document.getElementById("txtUsername").value;
        const Password = document.getElementById("txtPassword").value;
        const FirstName = document.getElementById("txtFirstName").value;
        const Surname = document.getElementById("txtSurname").value;
        const Currency = document.getElementById("selectCurrency").value;
        const singlePercentage = document.getElementById("txtSinglePercentage")
          ? document.getElementById("txtSinglePercentage").value
          : "0";
        const doublePercentage = document.getElementById("txtDoublePercentage")
          ? document.getElementById("txtDoublePercentage").value
          : "0";
        const triplePercentage = document.getElementById("txtTriplePercentage")
          ? document.getElementById("txtTriplePercentage").value
          : "0";

        // Check if password has 8 characters, and includes at least one number and one letter
        if (
          Password.length < 8 ||
          !/\d/.test(Password) ||
          !/[a-zA-Z]/.test(Password)
        ) {
          alert(
            _t(
              "Password must be at least 8 characters long and include at least one number and one letter!",
            ),
          );
          return;
        }

        const result = await createUser({
          name: FirstName,
          surname: Surname,
          currency: Currency,
          password: Password,
          username: Username,
          single_percentage: singlePercentage,
          double_percentage: doublePercentage,
          triple_percentage: triplePercentage,
          partner_type:
            singlePercentage != "0" ||
            doublePercentage != "0" ||
            triplePercentage != "0"
              ? "turnover_percentage"
              : "no_percentage",
        });

        if (result.success) {
          alert(result.error);
          if (result.success == "OK") window.location.href = "#/users";
        }
      });
    }
  },
  hideFooterCasino: true,
};

export default CreateUsers;
